module.exports = __webpack_public_path__ + "img/15.c3a62bdd.jpg";